/**
 * TikTok 视频播放组件（封面轮播 + 全屏播放器 + 视频内加购 + GA4 事件）
 * 标记: snippets/tiktok-video-gallery.liquid / snippets/tiktok-video-player.liquid
 * 设计: 07_ecom docs/plans/2026-10-13-shopify-tiktok-video-module-design.md §9 §10
 *
 * 红线:
 *  - 点击封面之前不创建任何 <video>/<iframe>，不加载任何第三方脚本。
 *  - 任何时刻最多一个播放器；关闭 / 切换时先暂停并移除旧的。
 *  - 无外部依赖（不依赖 jQuery；加购完成后复用主题自带的购物车侧栏函数，如果存在）。
 */
(function () {
  'use strict';
  if (window.__tvpLoaded) return;
  window.__tvpLoaded = true;

  var VIEWS_MIN = 10000;
  var IMPRESSED = {}; // video_id -> true，每页每视频只报一次曝光
  var dlg = null;     // 全屏弹层（首次打开时才创建）
  var state = { items: [], index: 0, opener: null, root: null, player: null };

  /* ---------- 小工具 ---------- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function el(tag, cls, attrs) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (attrs) Object.keys(attrs).forEach(function (k) { n.setAttribute(k, attrs[k]); });
    return n;
  }

  function formatViews(n) {
    n = Number(n) || 0;
    if (n >= 1e6) return trim(n / 1e6) + 'M';
    if (n >= 1e3) return trim(n / 1e3) + 'K';
    return String(n);
  }
  // 12.34 -> 12.3，12.0 -> 12；向下取整避免 9,999,999 显示成 10.0M
  function trim(x) { return (Math.floor(x * 10) / 10).toString().replace(/\.0$/, ''); }

  function publish(name, payload) {
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(name, payload);
      }
    } catch (e) { /* 埋点失败不能影响购物 */ }
  }

  function readData(item) {
    if (item._data) return item._data;
    var s = $('script[data-tvp-data]', item);
    try { item._data = JSON.parse(s.textContent); } catch (e) { item._data = null; }
    return item._data;
  }

  /* ---------- 页面内：曝光 / 观看数 / 轮播按钮 ---------- */
  function initRoot(root) {
    if (root._tvpInit) return;
    root._tvpInit = true;

    var items = $all('[data-tvp-item]', root);
    items.forEach(function (it) {
      var btn = $('[data-tvp-open]', it);
      var views = Number(btn.getAttribute('data-views')) || 0;
      var badge = $('[data-tvp-views]', it);
      if (badge && views >= VIEWS_MIN) {
        badge.textContent = formatViews(views);
        badge.hidden = false;
      }
    });

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          io.unobserve(e.target);
          var d = readData(e.target);
          if (!d || IMPRESSED[d.videoId]) return;
          IMPRESSED[d.videoId] = true;
          publish('tiktok_video_impression', { video_id: d.videoId, sku: d.product.sku, placement: d.placement });
        });
      }, { threshold: 0.5 });
      items.forEach(function (it) { io.observe(it); });
    }

    root.addEventListener('click', function (ev) {
      var open = ev.target.closest('[data-tvp-open]');
      if (open) {
        var item = open.closest('[data-tvp-item]');
        openDialog(root, items, items.indexOf(item), open);
        return;
      }
      var sc = ev.target.closest('[data-tvp-scroll]');
      if (sc) {
        var track = $('[data-tvp-track]', root);
        var dir = Number(sc.getAttribute('data-tvp-scroll'));
        track.scrollBy({ left: dir * track.clientWidth * 0.8, behavior: 'smooth' });
      }
    });

    var track = $('[data-tvp-track]', root);
    if (track && $('[data-tvp-scroll]', root)) {
      var upd = function () {
        var max = track.scrollWidth - track.clientWidth - 2;
        var prev = $('.tvp__nav--prev', root), next = $('.tvp__nav--next', root);
        // 卡片不够一屏时没有可滚动的内容，两个箭头都不显示（否则左箭头会压在第一张卡上）；
        // 几个像素的溢出是间距取整，不算可滚动
        var none = track.scrollWidth - track.clientWidth <= 8;
        if (prev) { prev.hidden = none; prev.disabled = track.scrollLeft <= 2; }
        if (next) { next.hidden = none; next.disabled = track.scrollLeft >= max; }
      };
      track.addEventListener('scroll', upd, { passive: true });
      window.addEventListener('resize', upd);
      upd();
    }
  }

  /* ---------- 弹层 ---------- */
  function buildDialog() {
    dlg = el('dialog', 'tvp-dialog', { 'aria-label': 'TikTok video' });
    dlg.innerHTML =
      '<div class="tvp-dialog__shell">' +
        '<button type="button" class="tvp-dialog__arrow tvp-dialog__arrow--prev" data-tvp-nav="-1" aria-label="Previous video">' +
          '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true" focusable="false"><path fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" d="M6 15l6-6 6 6"/></svg></button>' +
        '<div class="tvp-dialog__panel">' +
          '<div class="tvp-dialog__stage" data-tvp-stage>' +
            '<div class="tvp-dialog__player" data-tvp-player></div>' +
            '<div class="tvp-dialog__top">' +
              '<div class="tvp-dialog__meta">' +
                '<span class="tvp-dialog__handle" data-tvp-handle></span>' +
                '<span class="tvp-dialog__partner" data-tvp-partner hidden>Creator partner</span>' +
                '<span class="tvp-dialog__views" data-tvp-views-label hidden></span>' +
              '</div>' +
              '<a class="tvp-dialog__follow" data-tvp-follow target="_blank" rel="noopener" hidden><span data-tvp-follow-text>Follow on TikTok</span> <span aria-hidden="true">&#8599;</span><span class="tvp-sr"> (opens in a new tab)</span></a>' +
              '<button type="button" class="tvp-dialog__close" data-tvp-close aria-label="Close video">' +
                '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true" focusable="false"><path fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" d="M6 6l12 12M18 6L6 18"/></svg></button>' +
            '</div>' +
          '</div>' +
          '<div class="tvp-dialog__product" data-tvp-product>' +
            '<a class="tvp-dialog__pimg-link" data-tvp-plink tabindex="-1" aria-hidden="true"><img class="tvp-dialog__pimg" data-tvp-pimg alt="" width="56" height="56"></a>' +
            '<div class="tvp-dialog__pinfo">' +
              '<a class="tvp-dialog__ptitle" data-tvp-ptitle></a>' +
              '<span class="tvp-dialog__pprice" data-tvp-pprice></span>' +
            '</div>' +
            '<button type="button" class="tvp-dialog__cta" data-tvp-cta></button>' +
            '<a class="tvp-dialog__cta" data-tvp-cta-link hidden></a>' +
          '</div>' +
          '<p class="tvp-dialog__status" role="status" aria-live="polite" data-tvp-status></p>' +
        '</div>' +
        '<button type="button" class="tvp-dialog__arrow tvp-dialog__arrow--next" data-tvp-nav="1" aria-label="Next video">' +
          '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true" focusable="false"><path fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" d="M6 9l6 6 6-6"/></svg></button>' +
      '</div>';
    document.body.appendChild(dlg);

    dlg.addEventListener('click', function (e) {
      if (e.target.closest('[data-tvp-close]')) return closeDialog();
      var nav = e.target.closest('[data-tvp-nav]');
      if (nav) return go(Number(nav.getAttribute('data-tvp-nav')));
      if (e.target.closest('[data-tvp-cta]')) return addToCart();
      if (e.target.closest('[data-tvp-cta-link]')) return chooseOptions(e);
      // 点黑色背景（shell 本身 / dialog 本身）关闭
      if (e.target === dlg || e.target.classList.contains('tvp-dialog__shell')) closeDialog();
    });
    dlg.addEventListener('cancel', function (e) { e.preventDefault(); closeDialog(); }); // Esc
    dlg.addEventListener('close', teardownPlayer);
    dlg.addEventListener('keydown', onKey);

    // 触摸滑动: 竖滑（上一条/下一条，同 TikTok）或横滑
    var sx = 0, sy = 0, tracking = false;
    var stage = $('[data-tvp-stage]', dlg);
    stage.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) return;
      sx = e.touches[0].clientX; sy = e.touches[0].clientY; tracking = true;
    }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (!tracking) return;
      tracking = false;
      var t = e.changedTouches[0], dx = t.clientX - sx, dy = t.clientY - sy;
      var ax = Math.abs(dx), ay = Math.abs(dy);
      if (Math.max(ax, ay) < 70) return;
      if (ay >= ax) go(dy < 0 ? 1 : -1); else go(dx < 0 ? 1 : -1);
    }, { passive: true });
  }

  // Tab 焦点锁定在弹层内（原生 modal dialog 会让焦点溜到浏览器地址栏）
  function trapTab(e) {
    var f = $all('button, a[href], video[controls], iframe, [tabindex]:not([tabindex="-1"])', dlg).filter(function (n) {
      return !n.disabled && !n.hidden && n.getClientRects().length > 0 && n.getAttribute('tabindex') !== '-1';
    });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1], a = document.activeElement;
    if (e.shiftKey && (a === first || !dlg.contains(a))) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && (a === last || !dlg.contains(a))) { e.preventDefault(); first.focus(); }
  }

  function onKey(e) {
    if (e.key === 'Escape') return; // 交给 cancel 事件
    if (e.key === 'Tab') return trapTab(e);
    var onVideo = e.target && e.target.tagName === 'VIDEO'; // 左右键留给视频进度条
    if (e.key === 'ArrowDown' || e.key === 'PageDown' || (e.key === 'ArrowRight' && !onVideo)) { e.preventDefault(); go(1); }
    else if (e.key === 'ArrowUp' || e.key === 'PageUp' || (e.key === 'ArrowLeft' && !onVideo)) { e.preventDefault(); go(-1); }
  }

  function openDialog(root, items, index, opener) {
    if (!dlg) buildDialog();
    state.root = root; state.items = items; state.opener = opener;
    document.documentElement.classList.add('tvp-lock');
    if (!dlg.open) {
      if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
    }
    show(index);
    var close = $('[data-tvp-close]', dlg);
    if (close) close.focus();
  }

  function closeDialog() {
    if (!dlg) return;
    teardownPlayer();
    if (dlg.open) { if (typeof dlg.close === 'function') dlg.close(); else dlg.removeAttribute('open'); }
    document.documentElement.classList.remove('tvp-lock');
    var o = state.opener;
    state.opener = null;
    if (o && document.contains(o)) o.focus();
  }

  function go(step) {
    var n = state.items.length;
    if (n < 2) return;
    show((state.index + step + n) % n);
  }

  function teardownPlayer() {
    var holder = dlg && $('[data-tvp-player]', dlg);
    if (!holder) return;
    var v = $('video', holder);
    if (v) { try { v.pause(); } catch (e) {} v.removeAttribute('src'); try { v.load(); } catch (e2) {} }
    var f = $('iframe', holder);
    if (f) f.setAttribute('src', 'about:blank');
    holder.innerHTML = '';
    state.player = null;
  }

  function pickSource(sources) {
    if (!sources || !sources.length) return '';
    var target = 720;
    var sorted = sources.slice().sort(function (a, b) { return Math.abs((a.height || 0) - target) - Math.abs((b.height || 0) - target); });
    var conn = navigator.connection;
    if (conn && conn.saveData) { // 省流模式取最小的
      sorted = sources.slice().sort(function (a, b) { return (a.height || 0) - (b.height || 0); });
    }
    return sorted[0].url;
  }

  function show(index) {
    var item = state.items[index];
    var d = item && readData(item);
    if (!d) return;
    state.index = index;
    teardownPlayer(); // 同一时间只留一个播放器

    var holder = $('[data-tvp-player]', dlg);
    if (d.mode === 'hosted' && d.sources && d.sources.length) {
      var v = el('video', 'tvp-dialog__media', { playsinline: '', controls: '', preload: 'none', 'aria-label': 'Video by @' + d.handle });
      if (d.cover) v.setAttribute('poster', d.cover);
      v.src = pickSource(d.sources);
      holder.appendChild(v);
      var p = v.play(); // 来自用户点击，允许带声音自动播放；被拦截时保留控件让用户手动点
      if (p && p.catch) p.catch(function () {});
      state.player = v;
    } else {
      var f = el('iframe', 'tvp-dialog__media', {
        title: 'TikTok video' + (d.handle ? ' by @' + d.handle : ''),
        allow: 'autoplay; fullscreen; encrypted-media; picture-in-picture',
        allowfullscreen: '',
        referrerpolicy: 'strict-origin-when-cross-origin'
      });
      f.src = 'https://www.tiktok.com/player/v1/' + encodeURIComponent(d.videoId) + '?autoplay=1&rel=0';
      holder.appendChild(f);
      state.player = f;
    }

    // 文案
    var handle = $('[data-tvp-handle]', dlg);
    handle.textContent = d.handle ? '@' + d.handle : '';
    handle.hidden = !d.handle;
    $('[data-tvp-partner]', dlg).hidden = !d.partner;
    var vl = $('[data-tvp-views-label]', dlg);
    if (d.views >= VIEWS_MIN) { vl.textContent = formatViews(d.views) + ' views'; vl.hidden = false; } else { vl.hidden = true; }
    var fo = $('[data-tvp-follow]', dlg);
    if (d.profileUrl) {
      // 链接指向谁就写谁：自家视频 @<handle>，达人/买家视频指向品牌号（从品牌 URL 取 handle），避免误以为在关注达人
      var m = /\/@([^\/?#]+)/.exec(d.profileUrl);
      var who = (d.source === 'own' ? d.handle : (m && m[1])) || '';
      $('[data-tvp-follow-text]', dlg).textContent = who ? 'Follow @' + who + ' on TikTok' : 'Follow on TikTok';
      fo.href = d.profileUrl; fo.hidden = false;
    } else { fo.hidden = true; fo.removeAttribute('href'); }

    // 商品卡片
    var pr = d.product;
    var img = $('[data-tvp-pimg]', dlg);
    if (pr.image) { img.src = pr.image; img.hidden = false; } else { img.hidden = true; }
    $('[data-tvp-plink]', dlg).href = pr.url;
    var t = $('[data-tvp-ptitle]', dlg); t.textContent = pr.title; t.href = pr.url;
    $('[data-tvp-pprice]', dlg).textContent = (pr.priceFrom ? 'From ' : '') + pr.price;
    var cta = $('[data-tvp-cta]', dlg), link = $('[data-tvp-cta-link]', dlg);
    $('[data-tvp-status]', dlg).textContent = '';
    cta.disabled = false;
    if (pr.singleVariant) {
      cta.hidden = false; link.hidden = true;
      cta.disabled = !pr.available;
      cta.textContent = pr.available ? 'Add to cart' : 'Sold out';
    } else {
      cta.hidden = true; link.hidden = false;
      link.textContent = 'Choose options';
      link.href = pr.url;
    }

    var multi = state.items.length > 1;
    $all('.tvp-dialog__arrow', dlg).forEach(function (a) { a.hidden = !multi; });

    publish('tiktok_video_play', { video_id: d.videoId, sku: pr.sku, placement: d.placement, mode: d.mode });
  }

  /* ---------- 加购 ---------- */
  var ADD_FAIL = "Couldn't add to cart. Please try again.";

  // 多变体: 商品页上关弹层并滚到页面自己的变体选择器；其它页面照常跳商品页
  function chooseOptions(e) {
    var item = state.items[state.index];
    var d = item && readData(item);
    if (!d || d.placement !== 'pdp') return;
    var picker = $('.productView-options') || $('[data-product-attribute]');
    if (!picker) return;
    e.preventDefault();
    closeDialog();
    picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
    var f = $('input:not([type=hidden]), select, button', picker);
    if (f) setTimeout(function () { try { f.focus({ preventScroll: true }); } catch (x) { f.focus(); } }, 350);
  }

  function addToCart() {
    var item = state.items[state.index];
    var d = item && readData(item);
    if (!d) return;
    var cta = $('[data-tvp-cta]', dlg), status = $('[data-tvp-status]', dlg);
    if (cta.disabled) return;
    cta.disabled = true;
    cta.textContent = 'Adding…';
    status.textContent = '';
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: d.product.variantId, quantity: 1 })
    }).then(function (res) {
      if (!res.ok) {
        // 只有 Shopify 返回 JSON 且带 description（如库存不足）时才展示原文，其余一律通用文案
        return res.json().then(function (b) { throw new Error(b && typeof b.description === 'string' && res.status === 422 ? b.description : ADD_FAIL); },
          function () { throw new Error(ADD_FAIL); });
      }
      return res.json();
    }).then(function () {
      publish('tiktok_video_add_to_cart', { video_id: d.videoId, sku: d.product.sku, value: d.product.value, currency: d.product.currency });
      closeDialog();
      afterAdd();
    }).catch(function (err) {
      cta.disabled = false;
      cta.textContent = 'Add to cart';
      status.textContent = (err && err.message) || ADD_FAIL;
    });
  }

  // 复刻 theme.js actionAddToCart 的加购后分支（`halo` 是 theme.js 闭包变量，拿不到，只能自己做）:
  //   after_add_to_cart.type == 'quick_cart' 且 quick_cart.show -> 刷新并打开侧栏购物车；
  //   其余（'cart'、show=false，以及我们无法复刻的 popup_cart_*）-> 跳购物车页。
  // 两个设置均由 snippets/global-script.liquid 写到 window，读的是线上实时设置。
  function afterAdd() {
    var cartUrl = (window.routes && window.routes.cart) || '/cart';
    var aac = window.after_add_to_cart || {}, qc = window.quick_cart || {};
    var wrap = $('#halo-cart-sidebar .halo-sidebar-wrapper .previewCart-wrapper');
    if (aac.type !== 'quick_cart' || !qc.show || !wrap) { window.location.href = cartUrl; return; }
    var base = (window.routes && window.routes.root) || '';
    Promise.all([
      fetch(base + '/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }),
      fetch(base + '/cart?view=ajax_side_cart', { cache: 'no-store' }).then(function (r) { if (!r.ok) throw new Error('side cart'); return r.text(); })
    ]).then(function (res) {
      var cart = res[0];
      wrap.innerHTML = res[1];
      $all('[data-cart-count]').forEach(function (n) { n.textContent = cart.item_count; });
      document.dispatchEvent(new CustomEvent('cart-update', { detail: cart }));
      document.body.classList.add('cart-sidebar-show');
    }).catch(function () { window.location.href = cartUrl; });
  }

  /* ---------- 启动 ---------- */
  function boot() { $all('[data-tvp]').forEach(initRoot); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  // 主题编辑器 / AJAX 重渲染后重新初始化
  document.addEventListener('shopify:section:load', boot);
})();
